<template>
  <div class="page about-page">
    <section class="about-hero card">
      <div class="about-copy">
        <h1><span>A</span>bout SRfulfill</h1>
        <p>SRfulfill is a global Print on Demand and fulfillment platform under Sourong, established in 2015.</p>
        <p>We specialize in breaking the limitations of traditional manufacturing by connecting sourcing, customization, packaging, and global shipping into one seamless system.</p>
        <p>Our mission is to empower every entrepreneur with a scalable, high-efficiency, zero-inventory supply chain.</p>
        <div class="feature-row">
          <IconCard v-for="feature in features" :key="feature.title" v-bind="feature" compact />
        </div>
      </div>
      <FactoryVisual variant="about-factory">
        <div class="right_img_box">
          <img src="@/assets/img/company.png" alt="Factory Visual" />
        </div>
      </FactoryVisual>
    </section>

    <SectionTitle title="Our Story" />
    <section class="timeline">
      <article v-for="item in timeline" :key="item.title" class="timeline-card card">
        <span class="dot"></span>
        <h3>{{ item.title }}</h3>
        <p>{{ item.text }}</p>
        <div class="story-thumb"><img :src="item.img" class="team-img" /></div>
      </article>
    </section>

    <section class="story-panel">
      <div>
        <span class="quote-mark">"</span>
        <p>But throughout this journey, one problem became increasingly clear:</p>
        <strong>E-commerce brands don't just struggle with suppliers - they struggle with fragmented systems.</strong>
        <p>That fragmentation is exactly why we built SRfulfill.</p>
        <p>SRfulfill connects sourcing, customization, branding, and global fulfillment into one unified system.</p>
      </div>
      <div class="map-visual" aria-hidden="true">
        <img src="@/assets/img/world-network-600x250.png" style="width:100%;height:auto;object-fit: cover;" alt="Factory Visual" />
      </div>
    </section>

    <SectionTitle title="Meet Our Experts" />
    <section class="team-grid">
      <TeamCard v-for="member in team" :key="member.name" v-bind="member" />
    </section>

    <CtaBanner
      title="Ready to Build Your Brand With Confidence?"
      text="Let SRfulfill be your reliable partner in building, growing, and scaling your brand globally."
    />
  </div>
</template>
<style scoped>
.story-thumb .team-img{
  object-fit: cover;
  width:100%;
  margin:0 auto;
  height:auto;
  display:inline-block;
  height:90px;;
}
</style>
<script>
import CtaBanner from '@/components/CtaBanner.vue';
import FactoryVisual from '@/components/FactoryVisual.vue';
import IconCard from '@/components/IconCard.vue';
import SectionTitle from '@/components/SectionTitle.vue';
import TeamCard from '@/components/TeamCard.vue';
// team members data
import img1 from "@/assets/img/May Ma.jpg";
import img2 from "@/assets/img/Stella Yuan.jpg";
import img3 from "@/assets/img/Irene Sun.jpg";
import img4 from "@/assets/img/Jolie Lee.jpg";
import img5 from "@/assets/img/Zakiya Lai.jpg";
import img6 from "@/assets/img/Chloe Huang.jpg";
import img7 from "@/assets/img/Candy Chen.jpg";
// 关于我们
import t_img1 from "@/assets/img/abou_us_1.webp";
import t_img2 from "@/assets/img/2.webp";
import t_img3 from "@/assets/img/au_3.webp";
import t_img4 from "@/assets/img/au_4.webp";
import t_img5 from "@/assets/img/au_5.webp";
import t_img6 from "@/assets/img/au_6.webp";
export default {
  name: 'About',
  components: {
    CtaBanner,
    FactoryVisual,
    IconCard,
    SectionTitle,
    TeamCard
  },
  data() {
    return {
      features: [
        { icon: '📦', title: 'Global Sourcing Network', text: '' },
        { icon: '⏱', title: 'Flexible Customization Solutions', text: '' },
        { icon: '🛡️', title: 'Reliable Quality Control', text: '' },
        { icon: '🌐', title: 'Worldwide Fast Fulfillment', text: '' }
      ],
      timeline: [
        { title: '2015', text: 'We started as a small sourcing team helping sellers find reliable suppliers.',img:t_img1 },
        { title: 'Early Days', text: 'A small team handled sourcing through spreadsheets, messages, and calls.',img:t_img2 },
        { title: 'Scaling Up', text: 'Demand grew and manual workflows became harder to control.',img:t_img3 },
        { title: '2018', text: 'Expanded into a focused fulfillment coordination team.' ,img:t_img4},
        { title: '2021', text: 'Grew into a 30-person cross-border operations team.' ,img:t_img5},
        { title: 'Today', text: 'A 200+ member global fulfillment network supporting brands worldwide.' ,img:t_img6}
      ],
      team: [
        { name: 'May Ma', role: 'Fulfillment Specialist', tone: 'light',img:img1 },
        { name: 'Stella Yuan', role: 'Fulfillment Specialist', tone: 'blue',img:img2  },
        { name: 'Irene Sun', role: 'Fulfillment Specialist', tone: 'light',img:img3  },
        { name: 'Jolie Lee', role: 'Fulfillment Specialist', tone: 'dark' ,img:img4 },
        { name: 'Zakiya Lai', role: 'Fulfillment Specialist', tone: 'tan' ,img:img5 },
        { name: 'Chloe Huang', role: 'Fulfillment Specialist', tone: 'dark' ,img:img6 },
        { name: 'Cindy Chen', role: 'Fulfillment Specialist', tone: 'light',img:img7  }
      ]
    };
  }
};
</script>
